import api, { adminApiPrefix } from './Api';
import {
  Brand,
  brandFromResponse,
  brandToUpsertRequest,
} from '../interfaces/Brand/Brand';
import { BrandMediaOptions } from '../interfaces/Brand/BrandMediaOptions';

const brandAdminApiPrefix = `${adminApiPrefix}/brands`;

export const createBrand = async (brand: Brand): Promise<Brand> => {
  const response = await api.post(
    brandAdminApiPrefix,
    brandToUpsertRequest(brand),
  );

  return brandFromResponse(response.data?.data);
};

export const getBrands = async (): Promise<Brand[]> => {
  const response = await api.get(brandAdminApiPrefix, {
    params: { 'include-inactive': true },
  });

  return (response.data?.data ?? []).map((brand: any) =>
    brandFromResponse(brand),
  );
};

export const getBrand = async (id: number): Promise<Brand> => {
  const response = await api.get(`${brandAdminApiPrefix}/${id}`);

  return brandFromResponse(response.data?.data);
};

export const updateBrand = async (brand: Brand): Promise<Brand> => {
  const response = await api.put(
    `${brandAdminApiPrefix}/${brand.id}`,
    brandToUpsertRequest(brand),
  );

  return brandFromResponse(response.data?.data);
};

export const updateBrandMedia = async (
  id: number,
  options: BrandMediaOptions,
): Promise<Brand> => {
  const bodyFormData = new FormData();

  if (options.logo) {
    bodyFormData.append('logo', options.logo);
  }

  if (options.banner) {
    bodyFormData.append('banner', options.banner);
  }

  if (options.eraseLogo) {
    bodyFormData.append('erase-logo', '1');
  }

  if (options.eraseBanner) {
    bodyFormData.append('erase-banner', '1');
  }

  const response = await api.put(
    `${brandAdminApiPrefix}/media/${id}`,
    bodyFormData,
  );

  return brandFromResponse(response.data?.data);
};

export const deleteBrand = async (id: number): Promise<void> =>
  api.delete(`${brandAdminApiPrefix}/${id}`);
